import { createAction, props } from '@ngrx/store';
import { IQuotation } from './quotation.models';

export const setQuote = createAction(
  '[Quotation] Set Quote',
  props<{ quote: IQuotation }>()
);

export const updateQuotationPrice = createAction(
  '[Quotation] Update price',
  props<{ price: number }>()
);

export const saveQuotationsList = createAction(
  '[Quotation] Save quotation list',
  props<{ list: IQuotation[] }>()
);

export const updateQuotationIdEntidad = createAction(
  '[Quotation] Update idEntidad',
  props<{ idEntidad: number }>()
);

export const resetQuote = createAction('[Quotation] Reset Quote');
